<div class="content-box">
    <div class="content-box__base-information">
        <div class="content-box__base-information--title">
            {{title | translate}}
        </div>
        <div class="content-box__base-information--description">
            {{description | translate}} 
            <span *ngIf="renewalDate">
                <br *ngIf="description">
                {{ 'stats-and-resources.plan-will-renew-on' | translate }}
                {{ renewalDate | date : "dd.MM.yyyy" }}
            </span>
        </div>
        <!-- <div *ngIf="button" class="content-box__base-information--button"
             [ngClass]="{'content-box__base-information--button--red' : !(totalCount - currentCount > 0)}">
            <button (click)="addMoreResources()">
                +{{button | translate}}
            </button>
        </div> -->
    </div>
    <div class="content-box__doughnut">
        <app-doughnut [descriptionText]="chartDescriptionText"
                      [chartData]="getChartData()"
                      [colors]="chartColors"
                      [height]="doughnutHeight"
                      [width]="doughnutWidth">
        </app-doughnut>
    </div>
</div>